import apiClient from '../apiClient';

/**
 * Get list of completed extraction jobs available for rule testing
 * @param {string} customerId - Optional filter by customer ID
 * @param {number} rulesetTypeId - Optional filter by extraction ruleset type
 * @returns {Promise} API response with extraction job summaries
 */
export const getCompletedExtractionJobs = (customerId = null, rulesetTypeId = null) => {
  const params = {};
  if (customerId) {
    params.customerId = customerId;
  }
  if (rulesetTypeId) {
    params.rulesetTypeId = rulesetTypeId;
  }
  return apiClient.get('/rule-testing/extraction-jobs', { params });
};

/**
 * Execute selected rules against an extraction job or raw input data in test mode (no persistence)
 * @param {string} extractionJobId - The extraction job ID to test against (mutually exclusive with inputData)
 * @param {number[]} ruleIds - Array of rule IDs to execute
 * @param {object|null} inputData - Optional raw JSON input data (mutually exclusive with extractionJobId)
 * @returns {Promise} API response with test execution results
 */
export const executeRulesInTestMode = (extractionJobId, ruleIds, inputData = null) => {
  const payload = inputData
    ? { inputData, ruleIds }
    : { extractionJobId, ruleIds };
  return apiClient.post('/rule-testing/execute', payload);
};
